import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=ff3bb9d0&scoped=true&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=ff3bb9d0&prod&lang=scss&scoped=true&"
import style1 from "./OrderView.vue?vue&type=style&index=1&id=ff3bb9d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3bb9d0",
  null
  
)

export default component.exports